module.exports = __webpack_public_path__ + "static/img/index.214a985.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/other/GV/index.png
// module id = NHKC
// module chunks = 0